export const business = {
  legalName: 'Deleon Publishing LLC',
  email: 'support@deleonpublishing.com',
  phone: '+1 (555) 014-2280',
  phoneHref: 'tel:+15550142280',
  hours: 'Monday – Friday, 9:00 AM – 5:00 PM ET',
  responseTime: 'We respond to all inquiries within 1–2 business days.',
  address: {
    line1: 'Deleon Publishing LLC',
    line2: '1200 Corporate Drive, Suite 210',
    line3: 'Atlanta, GA 30303',
    line4: 'United States',
  },
}

export interface Policy {
  id: string
  title: string
  summary: string
  points: string[]
}

export const policies: Policy[] = [
  {
    id: 'refunds',
    title: 'Refund & Return Policy',
    summary:
      'We want you to be satisfied with every book you buy from us. Physical books may be returned for a full refund within 30 days of delivery.',
    points: [
      'Physical books may be returned within 30 days of delivery for a full refund of the purchase price.',
      'Books must be returned in resalable condition. Return shipping is paid by the customer unless the book arrived damaged, defective, or incorrect.',
      'If your order arrives damaged or incorrect, email us within 14 days of delivery and we will replace it or refund it in full, including shipping.',
      'Digital and ebook purchases are refundable within 14 days of purchase if the file is defective or was not delivered.',
      'Approved refunds are issued to the original payment method within 5–10 business days of us receiving the return.',
      'To start a return or refund, email support@deleonpublishing.com with your order number and the reason for the request.',
    ],
  },
  {
    id: 'cancellations',
    title: 'Cancellation Policy',
    summary:
      'Orders can be cancelled before they ship, and we do not sell subscriptions or recurring services.',
    points: [
      'Orders may be cancelled at no charge any time before they are shipped. Email us with your order number to cancel.',
      'If your order has already shipped, it can be handled as a return under our Refund & Return Policy above.',
      'Deleon Publishing LLC does not offer subscriptions, memberships, or recurring billing of any kind. You will never be charged on a recurring basis.',
      'Pre-orders and crowdfunding pledges may be cancelled at any time before the title ships, for a full refund.',
    ],
  },
  {
    id: 'shipping',
    title: 'Shipping & Delivery',
    summary:
      'Physical orders are printed and dispatched from the United States; ebooks are delivered instantly by email.',
    points: [
      'Physical orders are processed within 1–3 business days of payment.',
      'Domestic U.S. delivery typically takes 3–7 business days after dispatch. International delivery typically takes 7–21 business days.',
      'Shipping costs are calculated and shown at checkout before payment is confirmed.',
      'Ebook purchases are delivered by email download link immediately after payment is confirmed.',
      'International customers are responsible for any customs duties or import taxes.',
    ],
  },
  {
    id: 'privacy',
    title: 'Privacy & Payment Security',
    summary:
      'This site is served over secure HTTPS encryption and we never store your card details.',
    points: [
      'All pages are served over HTTPS with TLS encryption.',
      'Card payments are processed by Stripe. Deleon Publishing LLC never sees or stores your full card number.',
      'We collect only the information needed to fulfil your order and answer your inquiries: name, email, shipping address, and order details.',
      'We do not sell, rent, or share your personal information with third parties for marketing purposes.',
      'To request a copy of your data or its deletion, email support@deleonpublishing.com.',
    ],
  },
  {
    id: 'terms',
    title: 'Terms of Sale',
    summary:
      'The essentials that apply to every purchase made from Deleon Publishing LLC.',
    points: [
      'All prices are listed and charged in U.S. Dollars (USD).',
      'The total price, including shipping and applicable tax, is shown before you confirm payment.',
      'Titles are sold subject to availability. If a title is unavailable we will notify you and refund the purchase in full.',
      'All books, cover art, and site content are the copyright of Deleon Publishing LLC or its authors and may not be reproduced without written permission.',
      'These terms are governed by the laws of the State of Georgia, United States.',
    ],
  },
]
